import React, { FC } from 'react'

import { TModalComponentsItemProps } from '../../types/ContentHubSeriesDetails.type'
import CTAWithArrow from '../../../../react-only-components/CTAWithArrow'
import RoutableNotEditableLink from '../../../../react-only-components/RoutableNotEditableLink'
import Banner from '../ComponentDetails/Banner'

const InnerSplitModule: FC<TModalComponentsItemProps> = (props) => {
  const model = props.component

  return (
    <div className="inner-split-module">
      <div className="inner-split-module__image-wrapper">
        <Banner
          className="component-details-banner--16-9"
          component={model}
          hasFixedAspectRatio={true}
        />
      </div>
      <div className="inner-split-module__text-wrapper">
        <p className="inner-split-module__eyebrow">{model?.eyebrow}</p>
        <h2 className="inner-split-module__title">{model?.title}</h2>
        <div
          className="inner-split-module__description"
          dangerouslySetInnerHTML={{ __html: model?.description ?? '' }}
        ></div>
        <div className={'inner-split-module__buttons'}>
          {(model?.button1?.url || model?.button1?.label) && (
            <pfe-cta
              pfe-priority="primary"
              class="inner-split-module__primary-link"
            >
              <RoutableNotEditableLink href={model?.button1?.url}>
                {model?.button1?.label}
              </RoutableNotEditableLink>
            </pfe-cta>
          )}
          {(model?.button2?.url || model?.button2?.label) && (
            <CTAWithArrow
              href={model?.button2?.url}
              text={model?.button2?.label}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default InnerSplitModule
